var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RibbonGroupBase } from '../ribbon-interfaces';
/**
 * Represents the Page Numbers Group in Header & Footer tab
 * @private
 */
var PageNumbersGroup = /** @class */ (function (_super) {
    __extends(PageNumbersGroup, _super);
    /**
     * Constructor for the PageNumbersGroup
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    function PageNumbersGroup(container) {
        return _super.call(this, container) || this;
    }
    /**
     * Gets the ribbon group model for Page Numbers
     * @returns {RibbonGroupModel} The ribbon group model
     */
    PageNumbersGroup.prototype.getGroupModel = function () {
        return {
            header: this.localObj.getConstant('Page Numbers'),
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Page Numbers'),
            collections: [
                {
                    items: [
                        {
                            type: 'Button',
                            keyTip: 'NU',
                            buttonSettings: {
                                content: this.localObj.getConstant('Page Number'),
                                iconCss: 'e-icons e-de-ctnr-pagenumber',
                                clicked: this.pageNumberHandler.bind(this)
                            },
                            id: this.ribbonId + '_page_number',
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Add page numbers')
                            }
                        }
                    ]
                }
            ]
        };
    };
    /**
     * Handler for page number button click - inserts current page number at cursor position
     * @returns {void}
     */
    PageNumbersGroup.prototype.pageNumberHandler = function () {
        this.documentEditor.editorModule.insertPageNumber();
    };
    return PageNumbersGroup;
}(RibbonGroupBase));
export { PageNumbersGroup };
